import React from "react";
import { Navigate } from "react-router-dom";
import { useHelpVisibility } from "../hooks/useHelpVisibility";

/**
 * Wrapper de route pour gérer la visibilité publique du centre d'aide.
 * - Admin : passe toujours (override).
 * - Autres : si non-visible, redirige vers l'accueil. Pendant le chargement,
 *   on n'affiche rien (évite un flash de contenu).
 */
export default function HelpRouteGate({ children }) {
  const { visible, loading } = useHelpVisibility();
  if (loading) return null;
  if (!visible) return <Navigate to="/" replace />;
  return children;
}
